import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

const ChatbotContext = createContext();

export const useChatbot = () => useContext(ChatbotContext);

export const ChatbotProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messages.length === 0) {
      setMessages([{
        role: 'Perichert',
        content: 'Olá! Sou o chatbot Perichert. Estou aqui para ajudar com dúvidas sobre o funcionamento do sistema. Como posso ajudar você hoje?',
      }]);
    }
  }, []);

  return (
    <ChatbotContext.Provider value={{
      messages,
      setMessages,
      userInput,
      setUserInput,
      messagesEndRef,
      isModalOpen,
      setIsModalOpen
    }}>
      {children}
    </ChatbotContext.Provider>
  );
};
